import get from 'lodash/get';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';

import { DEFAULT_CURRENCY_PREFIX } from '../constants';

import formatPrice from './formatPrice';

const getPriceWithCurrency = (price, currencyFormatOptions) => {
  const currencyPrefix = get(currencyFormatOptions, 'currencyPrefix', DEFAULT_CURRENCY_PREFIX);

  if (!isString(price) && !isNumber(price)) return '';

  return `${currencyPrefix}${formatPrice(price, currencyFormatOptions)}`;
};

export default getPriceWithCurrency;
